import React from "react";
import { useParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import "./CategoryProductsPage.css";
import productsData from "../data/products";

function CategoryProductsPage() {
  const { categoryName, subCategoryName } = useParams();

  const filteredProducts = productsData.filter(
    (product) =>
      product.category.toLowerCase() === categoryName.toLowerCase() &&
      (!subCategoryName ||
        (product.subCategory &&
          product.subCategory.toLowerCase() === subCategoryName.toLowerCase()))
  );

  return (
    <div className="category-products-page">
      <h2 className="products-title">
        {categoryName}
        {subCategoryName ? ` - ${subCategoryName}` : ""}
      </h2>
      <div className="products-container">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))
        ) : (
          <p>No products found in this category.</p>
        )}
      </div>
    </div>
  );
}

export default CategoryProductsPage;
